// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2qxSw","title":"Images45_title__2D63F","images":"Images45_images__3u5Nw"};